// extracted by mini-css-extract-plugin
module.exports = {"component":"count-up_component__XDGm_"};